<div class="modal-content">
  <div class="modal-header">
    <h4 class="modal-title">{{ 'Add Client' | translate }}</h4>
    <div class="d-flex">
      <div class="mr-3">
        <i
          class="fal fa-fw fa-info-circle mr-2"
          placement="bottom"
          ngbTooltip="{{
            'Client is an organization ie. company or other legal entity'
              | translate
          }}"
        ></i
        >{{ 'Company' | translate }}
      </div>
      <div class="custom-control custom-checkbox-toggle custom-switch">
        <input
          type="checkbox"
          class="custom-control-input"
          id="isEndCustomer"
          (change)="onToggleClientType($event.target.checked)"
          [checked]="!clientForm.get('isEndCustomer').value"
        />
        <label class="custom-control-label" for="isEndCustomer"></label>
      </div>
      <button
        type="button"
        class="close"
        aria-label="Close"
        (click)="onClose()"
        style="margin-left: unset"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
  </div>
  <div class="modal-body">
    <form
      class="row"
      novalidate
      (ngSubmit)="onSave()"
      [formGroup]="clientForm"
      autocomplete="chrome-off"
    >
      <div class="col-md-6">
        <div class="form-group row">
          <label for="name" class="col-sm-4 col-form-label">
            <i
              class="fal fa-fw fa-info-circle mr-2"
              ngbTooltip="{{ 'Source: Public directories' | translate }}"
            ></i
            ><b>{{ 'Name' | translate }} *</b>
          </label>
          <div class="col-sm-8">
            <input
              #clientNameExists
              type="text"
              class="form-control data-hj-whitelist"
              tabindex="0"
              id="name"
              name="name"
              formControlName="name"
              [class.is-invalid]="
                sent && clientForm.get('name').hasError('required')
              "
              *ngIf="client && client.id"
            />

            <!-- Client search template -->
            <ng-template #companySearchTemplate let-r="result">
              <span *ngIf="r.id"
                ><b>{{ r.name }}</b></span
              >
              <span *ngIf="!r.id"
                ><b
                  ><i class="fas fa-plus-circle fa-xs fa-fw"></i>
                  {{ 'Save new' | translate }}: "{{ r.name }}"</b
                ></span
              ><br />
              <span>{{ r.address }} {{ r.city }}</span>
            </ng-template>

            <input
              #clientName
              *ngIf="!client.id"
              formControlName="name"
              name="clientSearch"
              [editable]="true"
              [focusFirst]="false"
              [ngbTypeahead]="companySearch"
              [resultTemplate]="companySearchTemplate"
              (selectItem)="onSelectCompany($event)"
              placeholder="{{
                'Search by name, address, tax num., ...' | translate
              }}"
              class="form-control data-hj-whitelist"
              [class.is-invalid]="
                sent && clientForm.get('name').hasError('required')
              "
            />

            <span class="loading-feedback" [hidden]="!loadingCompanies">
              <i class="fa fa-spinner-third fa-spin fa-md"></i>
            </span>

            <div
              class="invalid-feedback animate-show animate-fast"
              *ngIf="sent && clientForm.get('name').hasError('required')"
            >
              {{ 'global.validators.required.error' | translate }}
            </div>
          </div>
        </div>
        <hr />
        <div class="form-group row">
          <label for="address" class="col-sm-4 col-form-label">{{
            'Address' | translate
          }}</label>
          <div class="col-sm-8">
            <input
              type="text"
              class="form-control data-hj-whitelist"
              id="address"
              name="address"
              formControlName="address"
              [class.is-invalid]="
                sent && clientForm.get('address').hasError('required')
              "
            />

            <div
              class="invalid-feedback animate-show animate-fast"
              *ngIf="sent && clientForm.get('address').hasError('required')"
            >
              {{ 'Mandatory Eslog field' | translate }}
            </div>
          </div>
        </div>
        <div class="form-group row">
          <label for="address2" class="col-sm-4 col-form-label"></label>
          <div class="col-sm-8">
            <input
              type="text"
              class="form-control data-hj-whitelist"
              id="address2"
              name="address2"
              formControlName="address2"
            />
          </div>
        </div>
        <div class="form-group row">
          <label for="zip" class="col-sm-4 col-form-label">{{
            'client.zip.label' | translate
          }}</label>
          <div class="col-sm-8">
            <input
              type="text"
              class="form-control data-hj-whitelist"
              id="zip"
              name="zip"
              formControlName="zip"
              [class.is-invalid]="
                sent && clientForm.get('zip').hasError('required')
              "
            />

            <div
              class="invalid-feedback animate-show animate-fast"
              *ngIf="sent && clientForm.get('zip').hasError('required')"
            >
              {{ 'Mandatory Eslog field' | translate }}
            </div>
          </div>
        </div>
        <div class="form-group row">
          <label for="city" class="col-sm-4 col-form-label">{{
            'City' | translate
          }}</label>
          <div class="col-sm-8">
            <input
              type="text"
              class="form-control data-hj-whitelist"
              id="city"
              name="city"
              formControlName="city"
              [class.is-invalid]="
                sent && clientForm.get('city').hasError('required')
              "
            />

            <div
              class="invalid-feedback animate-show animate-fast"
              *ngIf="sent && clientForm.get('city').hasError('required')"
            >
              {{ 'Mandatory Eslog field' | translate }}
            </div>
          </div>
        </div>
        <div class="form-group row">
          <label for="country" class="col-sm-4 col-form-label">{{
            'Country' | translate
          }}</label>
          <div class="col-sm-8">
            <input
              type="text"
              class="form-control data-hj-whitelist"
              id="country"
              name="country"
              formControlName="country"
              [class.is-invalid]="
                sent && clientForm.get('country').hasError('required')
              "
              autocomplete="chrome-off"
            />
            <!-- <ng-select
              [items]="countries"
              bindLabel="nativeName"
              labelForId="nativeName"
              [virtualScroll]="true"
              formControlName="country"
              autocomplete="chrome-off"
              class="data-hj-whitelist"
            ></ng-select> -->

            <div
              class="invalid-feedback animate-show animate-fast"
              *ngIf="sent && clientForm.get('country').hasError('required')"
            >
              {{ 'Mandatory Eslog field' | translate }}
            </div>
          </div>
        </div>

        <hr />
        <div class="form-group row">
          <label for="contact" class="col-sm-4 col-form-label">{{
            'Contact person' | translate
          }}</label>
          <div class="col-sm-8">
            <input
              type="text"
              class="form-control data-hj-whitelist"
              id="contact"
              name="contact"
              formControlName="contact"
            />
          </div>
        </div>
        <div class="form-group row">
          <label for="phone" class="col-sm-4 col-form-label">{{
            'Phone' | translate
          }}</label>
          <div class="col-sm-8">
            <input
              type="text"
              class="form-control data-hj-whitelist"
              id="phone"
              name="phone"
              formControlName="phone"
            />
          </div>
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group row">
          <label for="email" class="col-sm-4 col-form-label"
            ><b>{{ 'E-mail' | translate }}</b></label
          >
          <div class="col-sm-8">
            <input
              type="text"
              class="form-control data-hj-whitelist"
              id="email"
              name="email"
              formControlName="email"
              [class.is-invalid]="
                sent && clientForm.get('email').hasError('invalidEmail')
              "
            />
            <span
              class="invalid-feedback"
              *ngIf="sent && clientForm.get('email').hasError('invalidEmail')"
              >{{ 'Please enter a valid e-mail' | translate }}</span
            >
          </div>
        </div>

        <hr />

        <div class="form-group row" *ngIf="!wls.getI('client-add.IBAN.hidden') && !hideEndCustomerSwitch">
          <label
            for="IBAN"
            class="col-sm-4 col-form-label"
            [class.text-secondary]="clientForm.get('isEndCustomer').value"
            >{{ 'IBAN' | translate }}</label
          >
          <div class="col-sm-8">
            <input
              type="text"
              class="form-control data-hj-whitelist"
              id="IBAN"
              name="IBAN"
              formControlName="IBAN"
              [class.is-invalid]="
                sent && clientForm.get('IBAN').hasError('required')
              "
            />

            <div
              class="invalid-feedback animate-show animate-fast"
              *ngIf="sent && clientForm.get('IBAN').hasError('required')"
            >
              {{ 'Mandatory Eslog field' | translate }}
            </div>
          </div>
        </div>

        <div class="form-group row" *ngIf="!wls.getI('client-add.SWIFT.hidden')">
          <label
            for="SWIFT"
            class="col-sm-4 col-form-label"
            [class.text-secondary]="clientForm.get('isEndCustomer').value"
            >{{ 'BIC/SWIFT' | translate }}</label
          >
          <div class="col-sm-8">
            <input
              type="text"
              class="form-control data-hj-whitelist"
              id="SWIFT"
              name="SWIFT"
              formControlName="SWIFT"
              [class.is-invalid]="
                sent && clientForm.get('SWIFT').hasError('required')
              "
            />

            <div
              class="invalid-feedback animate-show animate-fast"
              *ngIf="sent && clientForm.get('SWIFT').hasError('required')"
            >
              {{ 'Mandatory Eslog field' | translate }}
            </div>
          </div>
        </div>

        <div class="form-group row" *ngIf="!wls.getI('client-add.bank.hidden')">
          <label
            for="bank"
            class="col-sm-4 col-form-label"
            [class.text-secondary]="clientForm.get('isEndCustomer').value"
            >{{ 'Name of bank' | translate }}</label
          >
          <div class="col-sm-8">
            <input
              type="text"
              class="form-control data-hj-whitelist"
              id="bank"
              name="bank"
              formControlName="bank"
              [class.is-invalid]="
                sent && clientForm.get('bank').hasError('required')
              "
            />

            <div
              class="invalid-feedback animate-show animate-fast"
              *ngIf="sent && clientForm.get('bank').hasError('required')"
            >
              {{ 'Mandatory Eslog field' | translate }}
            </div>
          </div>
        </div>

        <hr *ngIf="!(wls.getI('client-add.bank.hidden') && wls.getI('client-add.SWIFT.hidden') && wls.getI('client-add.IBAN.hidden'))" />

        <div class="form-group row">
          <label for="taxNumber" class="col-sm-4 col-form-label">{{
            'Tax number' | translate
          }}</label>
          <div class="col-sm-8">
            <input
              type="text"
              class="form-control data-hj-whitelist"
              id="taxNumber"
              name="taxNumber"
              formControlName="taxNumber"
              [class.is-invalid]="
                sent && clientForm.get('taxNumber').hasError('required')
              "
            />

            <div
              class="invalid-feedback animate-show animate-fast"
              *ngIf="sent && clientForm.get('taxNumber').hasError('required')"
            >
              {{ 'Mandatory Eslog field' | translate }}
            </div>
          </div>
        </div>
        <div class="form-group row">
          <label
            for="companyNumber"
            class="col-sm-4 col-form-label"
            [class.text-secondary]="clientForm.get('isEndCustomer').value"
            >{{ 'Company number' | translate }}</label
          >
          <div class="col-sm-8">
            <input
              type="text"
              class="form-control data-hj-whitelist"
              id="companyNumber"
              name="companyNumber"
              formControlName="companyNumber"
              [class.is-invalid]="
                sent && clientForm.get('companyNumber').hasError('required')
              "
            />

            <div
              class="invalid-feedback animate-show animate-fast"
              *ngIf="
                sent && clientForm.get('companyNumber').hasError('required')
              "
            >
              {{ 'Mandatory Eslog field' | translate }}
            </div>
          </div>
        </div>
        <!-- taxSubject -->
        <div class="form-group row">
          <div class="col-sm-4">
            <label
              class="form-check-label"
              for="taxSubject"
              [class.text-secondary]="clientForm.get('isEndCustomer').value"
              >{{ 'Tax subject' | translate }}</label
            >
          </div>
          <div class="col-sm-8 pl-3">
            <div class="custom-control custom-checkbox-toggle custom-switch">
              <input
                type="checkbox"
                class="custom-control-input"
                id="taxSubject"
                [attr.disabled]="
                  clientForm.get('isEndCustomer').value ? 'disabled' : null
                "
                formControlName="taxSubject"
              />
              <label class="custom-control-label" for="taxSubject"></label>
            </div>
          </div>
        </div>
        <!--// taxSubject -->

        <!-- type -->
        <div class="form-row">
          <label for="type" class="col-sm-4 col-form-label">{{
            'clients.client-add.form.type.label' | translate
          }}</label>
          <div class="col-sm-8">
            <select
              type="text"
              class="form-control data-hj-whitelist"
              id="type"
              name="type"
              formControlName="type"
            >
              <option value="">
                {{ 'clients.client-add.form.type.both' | translate }}
              </option>
              <option value="customer">
                {{ 'clients.client-add.form.type.customer' | translate }}
              </option>
              <option value="supplier">
                {{ 'clients.client-add.form.type.supplier' | translate }}
              </option>
            </select>
          </div>
        </div>
        <!--// type -->
      </div>

      <!-- Custom properties (_data) -->
      <div class="col-12" *ngIf="!wls.getI('client-add._data.hidden')">
        <hr />

        <div class="row">
          <div
            formArrayName="_data"
            class="col-12 mb-2"
            *ngFor="let field of dataFA.controls; let i = index"
          >
            <div class="form-row" [formGroupName]="i">
              <!-- Remove -->
              <div class="col-auto">
                <p class="small font-weight-bold mb-2" *ngIf="i === 0">
                  &nbsp;
                </p>
                <button
                  class="btn btn-outline-secondary btn-sm"
                  (click)="onRemoveData(i)"
                >
                  <i class="fe fe-trash fa-fw"></i>
                </button>
              </div>
              <!-- name -->
              <div class="col-sm-2">
                <p class="small font-weight-bold mb-2" *ngIf="i === 0">
                  {{ 'clients.client-add.form._data.name.label' | translate }}
                </p>
                <input
                  type="text"
                  class="form-control form-control-sm data-hj-whitelist"
                  id="data_name_{{ i }}"
                  name="data_name_{{ i }}"
                  formControlName="name"
                  placeholder="{{
                    'clients.client-add.form._data.name.placeholder' | translate
                  }}"
                  [class.is-invalid]="
                    sent &&
                    clientForm.get('_data.' + i + '.name').hasError('required')
                  "
                />
              </div>
              <!-- value -->
              <div class="col-sm-3">
                <p class="small font-weight-bold mb-2" *ngIf="i === 0">
                  {{ 'clients.client-add.form._data.value.label' | translate }}
                </p>
                <input
                  type="text"
                  class="form-control form-control-sm data-hj-whitelist"
                  id="data_value_{{ i }}"
                  name="data_value_{{ i }}"
                  formControlName="value"
                  placeholder="{{
                    'clients.client-add.form._data.value.placeholder'
                      | translate
                  }}"
                />
              </div>
              <!-- Options -->
              <div class="col-auto">
                <p
                  class="small font-weight-bold mb-3"
                  *ngIf="i === 0"
                  ngbTooltip="{{
                    'clients.client-add.form._data.onPDF.limit-tooltip'
                      | translate
                  }}"
                >
                  {{
                    'clients.client-add.form._data.options.onPDF.label'
                      | translate
                  }}
                  <i class="fe fe-info"></i>
                </p>
                <div class="form-check mt-1" formGroupName="options">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    id="onPDF_{{ i }}"
                    formControlName="onPDF"
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="col-12">
            <button
              class="btn btn-outline-secondary btn-sm mt-3"
              type="button"
              (click)="onAddData()"
              [disabled]="!save && clientForm.get('_data').value.length >= 2"
            >
              <i class="fe fe-plus"></i>
              {{ 'clients.client-add.form._data.add' | translate }}
            </button>
          </div>
        </div>
      </div>
      <!--// Custom properties (_data) -->
    </form>
  </div>

  <div class="modal-footer">
    <button class="btn btn-outline-secondary" type="button" (click)="onClose()">
      {{ 'Cancel' | translate }}
    </button>
    <button class="btn btn-primary" type="button" (click)="onSave()">
      <span *ngIf="!client || !client.id">{{ 'global.save' | translate }}</span>
      <span *ngIf="client && client.id">{{ 'Update' | translate }}</span>
      <span *ngIf="loading"
        >&nbsp; <i class="fa fa-spinner-third fa-spin fa-md fa-lg"></i
      ></span>
    </button>
  </div>
</div>
